export default __webpack_public_path__ + "static/media/088-duo.4d086a96.svg";